export default __webpack_public_path__ + "static/media/void-cheque-1x.0e08804d.png";